import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { DEFAULT_LOCALE } from 'lib/core/resources/constants'
import { Slice } from './types'

export const initialState: Slice = DEFAULT_LOCALE

const slice = createSlice({
  name: 'common/locale',
  initialState,
  reducers: {
    setLocale (state, action: PayloadAction<string>) {
      state = action.payload
    }
  }
})

export const reducer = slice.reducer

export const { setLocale } = slice.actions
